export default "__VITE_ASSET__Bu3LS2cV__"